import { Typography } from 'shared/components/Typography';

export const MomentumTitle = () => (
  <Typography as="h3" type="body" color="black" fontWeight="semibold">
    Momentum Score
  </Typography>
);
